import React from 'react';
import { Camera, Upload } from 'lucide-react';

export function ScannerReceiptHeader({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative z-10 px-4">
      <div className="mt-2 rounded-2xl bg-black/70 border border-white/10 p-3 shadow-lg">{children}</div>
    </div>
  );
}

export function ScannerReceiptControls({
  useNativeCameraOnly,
  receiptSaveDisabled,
  receiptSaveDisabledReason,
  isDragActive,
  onCapture,
  onFileChange,
  onDrop,
  onDragOver,
  onDragLeave,
}: {
  useNativeCameraOnly: boolean;
  receiptSaveDisabled: boolean;
  receiptSaveDisabledReason?: string;
  isDragActive: boolean;
  onCapture: () => void;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDrop: (event: React.DragEvent<HTMLDivElement>) => void;
  onDragOver: (event: React.DragEvent<HTMLDivElement>) => void;
  onDragLeave: (event: React.DragEvent<HTMLDivElement>) => void;
}) {
  return (
    <div className="absolute bottom-0 left-0 right-0 z-30 flex flex-col items-center justify-end pb-8 sm:pb-6 pointer-events-none">
      <div className="flex flex-col items-center gap-4 pointer-events-auto px-4 w-full max-w-sm">
        <div className="flex items-center justify-center gap-6 w-full">
          <div className="w-12 h-12" />

          {!useNativeCameraOnly && (
            <button
              onClick={onCapture}
              className="w-20 h-20 rounded-full border-4 border-white/60 bg-white/20 p-1 flex items-center justify-center shadow-2xl backdrop-blur-md transition-transform active:scale-90 hover:scale-105 disabled:opacity-50"
              aria-label="Capture photo"
              type="button"
              disabled={receiptSaveDisabled}
            >
              <div className="w-full h-full rounded-full bg-ninpo-lime text-ninpo-black flex items-center justify-center shadow-[0_0_20px_rgba(163,230,53,0.5)]">
                <Camera className="w-8 h-8" />
              </div>
            </button>
          )}

          <label
            className="w-12 h-12 rounded-full bg-black/60 border border-white/20 backdrop-blur-md flex items-center justify-center text-white cursor-pointer active:scale-95 hover:bg-black/80 transition shadow-lg"
            title="Upload image"
          >
            <Upload className="w-5 h-5" />
            <input
              type="file"
              accept="image/*"
              capture="environment"
              className="hidden"
              onChange={onFileChange}
              disabled={receiptSaveDisabled}
            />
          </label>
        </div>

        <div
          onDrop={onDrop}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          className={`hidden sm:flex w-48 h-14 items-center justify-center border-2 border-dashed rounded-xl transition-colors ${
            isDragActive ? 'border-ninpo-lime bg-ninpo-lime/10' : 'border-white/20 bg-black/40'
          }`}
          style={{ pointerEvents: 'auto' }}
        >
          <span className="text-xs text-white/70 font-medium">Drag & drop receipt</span>
        </div>

        {receiptSaveDisabledReason && (
          <div className="text-xs text-ninpo-red font-bold text-center px-3 py-1 rounded-full bg-black/70 backdrop-blur-sm border border-ninpo-red/30">
            {receiptSaveDisabledReason}
          </div>
        )}
      </div>
    </div>
  );
}
